import Vue from 'vue'
import {Fetch} from '../utils/storage'
import {Api} from "./api"
import {Save} from "./storage"

const CheckLoginIn = async (backUrl = window.location.href) =>{
    try {
        if (!Fetch('Token'))  {
            await SignIn(backUrl)
        }
        await GetInfo()
    }catch(err) {
        Vue.$vux.toast.show({
            text: '登录错误！',
            type: 'text',
            width:'3rem'
        })
    }
}

const SignIn = async (backUrl=window.location.href)=>{
    let urlParams = window.location.href.split('?')
    urlParams.splice(0, 1)
    let code = getCode(urlParams)
    if (code == null) {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + process.env.VUE_APP_APP_ID + '&redirect_uri=' +
            encodeURIComponent(backUrl) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        return
    }
    let signRes = await Api('SignIn',{
        Code: code
    })
    Save('Token', signRes.data.Token)
    window.location.reload()
}


const GetInfo = async ()=> {
    try {
        let res = await Api('GetInfo')
        Save('ID',res.data.ID)
        Save('NickName',res.data.NickName)
        Save('HeadImg',res.data.HeadImg)
        return res.data
    }catch(err) {
        Vue.$vux.toast.show({
            text: '获取个人信息失败！',
            type: 'text',
            width:'3rem'
        })
    }
}



function getCode (urlParams) {
    let code = null
    urlParams.forEach((item) => {
        let _searchParams = new URLSearchParams(item)
        if (_searchParams.has('code')) {
            code = _searchParams.get('code')
        }
    })
    return code
}


export {CheckLoginIn, GetInfo, SignIn}
